import AccordeonDetail from './AccordeonDetail'
export default AccordeonDetail
